import { render, staticRenderFns } from "./businessBanner.vue?vue&type=template&id=0689da94&scoped=true&"
import script from "./businessBanner.vue?vue&type=script&lang=js&"
export * from "./businessBanner.vue?vue&type=script&lang=js&"
import style0 from "./businessBanner.vue?vue&type=style&index=0&id=0689da94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0689da94",
  null
  
)

export default component.exports